import { Button, Divider } from "@mui/material";

import Alert from "../../../assets/Icons/Alert";
import Modal from "../Modal";
import PropTypes from "prop-types";

const failReasons = {
  InvalidPromoCode: "The promo code you entered is invalid. Please try again.",
  TimedOut:
    "It looks like your session has timed out due to inactivity. Please refresh the page to restart your session.",
  InvalidRate:
    "It looks like the rate you selected isn't valid. Please choose a different rate.",
  PaymentFailed: "Your payment didn't go through. Please try again.",
  MissingWebSession: "Something went wrong on our end. Please try again.",
  PromoMaxUsageReached: "This promo code has reached its usage limit.",
  SessionInViolation:
    "This plate is currently in violation status. Parking activation is no longer available.",
  InvalidCode:
    "The code you entered isn't valid. Please double-check and try again.",
  MaxUsageReached:
    "This code has reached its usage limit and is no longer valid.",
  InvalidForRate:
    "This code cannot be applied to the selected rate. Please select a different rate or use another code.",
  InvalidForLot: "This code is not valid for the lot you are parked in.",
  invalidTicket: "Unable to find the submitted barcode. Please try again",
  unknownSystemError:
    "Unknown system error. Please try again. If the issue persists try restarting the app or contacting support",
  invalidPlateOrState:
    "Invalid license plate number. Please confirm that your information is correct and try again",
  missingWebSession:
    "A system error occurred. Please try again. If the issue persists try restarting the app or contacting support. Error code 4005",
  missingTDCPriceScale:
    "A system error occurred. Please try again. If the issue persists try restarting the app or contacting support. Error code 4003",
  missingParkingSessionLotInfo:
    "A system error occurred. Please try again. If the issue persists try restarting the app or contacting support. Error code 4002",
  missingValidZonesForTicket:
    "A system error occurred. Please try again. If the issue persists try restarting the app or contacting support. Error code 4004",
  ticketRedeemed: "This parking pass has already been redeemed.",
  sessionInViolation:
    "This plate is currently in violation status. Parking activation is no longer available.",
  cameraPermissionsDenied:
    "Camera permission denied. Please allow camera access to scan.",
  suitableCameraNotFound:
    "No suitable camera found. Please ensure your device has a camera.",
  SessionAlreadyPaid:
    "A parking pass has already been activated for this plate.",
  WindowClosed: "The license plate may no longer be changed.",
  PlateNotSimilar:
    "Only minor corrections are allowed. The new plate is too different from the original to be updated.",
  InvalidPlate:
    "Invalid license plate number. Please confirm that your information is correct and try again.",
  SystemError:
    "An error occured, please try again or contact support if the problem persists.",
  AlreadyPaid: "A parking pass has already been activated for this plate. ",
  AlreadyPaidPlateSwitch:
    "A parking pass has already been activated for the submitted plate.",
  SessionEnforced:
    "This plate is currently in violation status. Plate switching is no longer available.",
  NotEligible: "This plate is not eligible for plate switching.",
};

const ErrorModal = (props) => {
  const { open = false, onClose, failReason, description } = props;

  return (
    <Modal open={open} onClose={onClose}>
      <div>
        <span className="mx-auto">
          <Alert />
          <div>
            <div className="text-center mt-4 font-bold text-lg">Warning</div>
            {failReason && (
              <div className="text-center mt-4">
                {failReasons[failReason] ?? failReasons["unknownSystemError"]}
              </div>
            )}
            {description && (
              <div className="text-center mt-4">{description}</div>
            )}
            <div
              className="mt-4"
              style={{ marginLeft: "-1.5rem", marginRight: "-1.5rem" }}
            >
              <Divider />
            </div>
            <div>
              <div className="mt-4 flex justify-center">
                <Button
                  size="medium"
                  variant="contained"
                  onClick={onClose}
                  color="primary"
                  style={{
                    fontWeight: 700,
                    height: "2.5rem",
                    width: "49%",
                  }}
                >
                  Take Me Back!
                </Button>
              </div>
            </div>
          </div>
        </span>
      </div>
    </Modal>
  );
};

ErrorModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  failReason: PropTypes.string,
  description: PropTypes.string,
};

export default ErrorModal;
